import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import './A4-breadcrumb.scss';

class A4Breadcrumb extends Abstract {
	init() {
		this.store = this.getState('global');

		this.subscribe(this.onStoreUpdate);
		this.onStoreUpdate();
	}

	onStoreUpdate = () => {
		this.store = this.getState('global');
		this.checkSlider();
	}

	checkSlider = () => {
		const { viewport } = this.store;
		const sliderEl = this.root.querySelector('.swiper-container');

		if (['xs', 'sm'].includes(viewport) && typeof this.slider === 'undefined') {
			this.slider = new Slider(sliderEl, {
				speed: 500,
				autoplay: false,

				simulateTouch: false,
				preventInteractionOnTransition: true,

				navigation: {
					nextEl: '.js-button-next',
					prevEl: '.js-button-prev',
				},
			});
		}

		if (['md', 'lg', 'xl', 'xxl'].includes(viewport) && typeof this.slider !== 'undefined') {
			this.slider.destroy();
			delete this.slider;
		}
	}
}

export default A4Breadcrumb;
